import * as React from 'react';



export default class Sortuparrow extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg className={this.props.className} onClick={this.props.onClick} xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13">
            <path d="M4 0L7.4641 6H0.535898L4 0Z" fill="#333333"/>
            <path d="M4 13L7.4641 7H0.535898L4 13Z" fill="#B0B0B0"/>
        </svg>
    )
  }
}








